// Fetches a fresh CSRF token from Craft's native, guest-safe session endpoint
// (users/session-info), memoized so it hits the origin at most once per page.
//
// This replaces the home-grown /actions/co/general/get-csrf-token endpoint:
// behaviors that need a token import this rather than each fetching their own.
// Because it's the endpoint Craft's own asyncCsrfInputs uses, a page that also
// renders {{ csrfInput() }} shares one round trip instead of two.
//
// Resolves to the session-info JSON, which includes { csrfTokenName,
// csrfTokenValue }, or null if the request failed (a later call retries).
let csrfPromise = null;

export function fetchCsrfToken() {
    if (!csrfPromise) {
        const base = (window.SITE_URL || '/').replace(/\/+$/, '');
        csrfPromise = fetch(base + '/actions/users/session-info', {
            credentials: 'same-origin',
            headers: { Accept: 'application/json' },
        })
            .then((response) => response.json())
            .catch((error) => {
                // Drop the cache so the next interaction can retry.
                csrfPromise = null;
                console.error('CSRF token fetch failed:', error);
                return null;
            });
    }

    return csrfPromise;
}

// Populates hidden CSRF inputs under `root` with a fresh token, so a normally
// submitted form carries a valid token even when its HTML was full-page cached.
// Defaults to inputs named after Craft's csrfTokenName; pass `fieldName` for a
// form that uses a different field (e.g. profileForm posts to an external target
// expecting CRAFT_CSRF_TOKEN). Returns the token JSON so callers can await it
// before submitting.
export function hydrateCsrfInputs(root = document, fieldName = null) {
    return fetchCsrfToken().then((data) => {
        if (!data) return null;
        const name = fieldName || data.csrfTokenName;
        root
            .querySelectorAll(`[name="${name}"]`)
            .forEach((field) => { field.value = data.csrfTokenValue; });
        return data;
    });
}
